import ModalFormBarangJadi from './ModalFormBarangJadi';

export default ModalFormBarangJadi;
